import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AppComponent } from 'src/app/app.component';

import { AuthenticationService } from 'src/app/_services/authentication.service';

import { CompaniesComponent } from '../companies.component';

@Component({
  selector: 'app-add-company',
  templateUrl: './add-company.component.html',
  styleUrls: ['./add-company.component.scss']
})
export class AddCompanyComponent implements OnInit {

  @ViewChild('closeBtn') closeBtn: ElementRef;

  addCompanyForm: FormGroup;
  missingFieldMsg = false;

  constructor(private formBuilder: FormBuilder,
    private authService: AuthenticationService,
    private companies: CompaniesComponent, private appComp: AppComponent ) { }

  ngOnInit(): void {
    this.addCompanyForm = this.formBuilder.group({
      name: ["", Validators.required],
      contact: ["", Validators.required],
      address1: ["", Validators.required],
      address2: [""],
      city: ["", Validators.required],
      state: ["", Validators.required],
      zip: ["", Validators.required],
      phone: ["", Validators.required],
      email: ["", Validators.required],
      contactPhone: ["", Validators.required],
      contactEmail: ["", Validators.required],
      isLoan: [Boolean, Validators.required],
      active: [null],
    });
  }

  addCompany(){
    this.appComp.loading = true;
    this.missingFieldMsg = false;
    if (this.addCompanyForm.invalid) {
      this.missingFieldMsg = true;
      this.appComp.loading = false;
      return;
    }
    let formObj = this.addCompanyForm.getRawValue();
    console.log(formObj);
    formObj.active = true;
    this.authService.addCompany(formObj).then(res=>{
      console.log(res);
      this.closeBtn.nativeElement.click();
      this.companies.getCompanies();
      this.appComp.loading = false;
    }, err =>{
      console.log(err);
      this.appComp.loading = false;
    })
  }

}
